import { h, r as registerInstance, c as createEvent, F as Fragment, H as Host, g as getElement } from './index-5faac9d7.js';
import { d as EQdsButtonSize, c as EQdsButtonImportance, _ as RangeCTAPosition, $ as ADDITIONAL_CTA_LINKS, a0 as NUMBER_OF_BUTTONS_BEFORE, a1 as MAX_CTA_LIMIT, b as productCtas, a2 as ECommercialStatus, a3 as DEFAULT_CTA_DROPDOWN_LABEL, H as productCtasButtonType, p as productCtasColors, j as EEvent, W as RANGE, U as ETabType, a4 as CAASContentOverviewSlotName, a5 as rangeBasePath } from './currency-49e0d692.js';
import { E as isLinkTypeOnline, D as isTargetBlank, x as deepMerge, t as tryParse, V as comparator, s as scrollToComponent } from './index-39f51a91.js';
import { u as updateProductCtasSelectorSettings } from './product-selector-utils-df1f9eca.js';
import { o as onDownloadLinkClickGA, g as getPriorityNumber, a as onSoftwareDocumentDialogClick, b as addRangeClickGAEvent } from './helper-baea569d.js';
import { s as send, x as productSelectorVirtualPageEvent, q as paginationClickEvent, X as setPaginationParams, Y as setArticleTitle, D as rangeTabClickEvent } from './analytics-74fe4f64.js';
import { c as classnames } from './index-43880fda.js';
import { i as isMobile } from './utils-6c8f178b.js';
import { g as getData } from './http-65330442.js';
import { g as getSelectorConfigUrl, R as RANGE_ENDPOINT } from './urls-7ce07a24.js';
import { a as addParameterToLink, g as getQueryParam, p as pasteScripts, s as scrollToTop, f as getRangeFilterUrl, h as getSelectedNodeIdFromUrl, b as getCountry, d as getLanguage, i as getLocaleWithV3, j as filterReset, k as setNavigationFilterPath, l as getPaginationParams, m as getPbsFilterProductsUrl, n as getFilterProductsUrl, o as parseRichText, e as getAnalyticsPageLoadData, q as getBaseUrl, r as pageParam } from './helpers-cd261aee.js';
import { d as decodeFromURI } from './index-67820103.js';
import { g as getMyProductsFromConnector } from './utils-e1285d4c.js';
import { i as isEmpty_1 } from './isEmpty-ea893565.js';
import { T as TAB_NAMES, F as FILTER_STATE_CHANGED_EVENT_NAME, g as rangeTabs } from './analytics-b3108572.js';
import { D as DEFAULT_NAVIGATION_STATE } from './navigation-83d2f79a.js';
import { t as trackFilterAnalytics, f as fetchSprykerFilters } from './normalizeFiltersData-907232a7.js';
import { c as calculateCurrentNodeParams, g as getCurrentReference, a as getRangeNodesIds } from './range-helpers-582889ff.js';
import { j as join } from './path-3461bbf6.js';
import './_commonjsHelpers-7db8bc26.js';
import './lodash-7f024380.js';
import './_nodeUtil-549406aa.js';
import './_Stack-cf94d4e7.js';
import './constants-7d3b1dc0.js';
import './number-fcf5283d.js';
import './tslib.es6-613ce1cd.js';
import './_isIndex-3036d479.js';
import './toNumber-d92ee08f.js';
import './isSymbol-8fefec05.js';
import './toString-568546f3.js';

const CtaSoftwareDropdownItem = ({ additionLinks, labels, numberOfButtonsBefore, ctaItem, position, }) => {
  if (!additionLinks.length)
    return null;
  if (additionLinks.length === 1) {
    const { url, type, target, reference, fileName, docType } = additionLinks[0];
    const attr = isTargetBlank(target) ? { target: '_blank' } : { download: '' };
    return (h("a", Object.assign({ class: "cta-software-dropdown-link", href: url }, attr, { onClick: () => onDownloadLinkClickGA(additionLinks[0], ctaItem, position), "data-da-element-id": "download_if", "data-da-priority": getPriorityNumber(numberOfButtonsBefore), "data-doc-reference": reference, "data-doc-name": fileName, "data-doc-type": docType }),
      h("se-list-item", { item: isLinkTypeOnline(type)
          ? labels.onlineLabel
          : labels.offlineLabel })));
  }
  return (h("se-list-item", null,
    h("button", { class: "cta-software-dropdown-button", onClick: () => onSoftwareDocumentDialogClick(additionLinks[0].type, additionLinks, labels, ctaItem, position), "data-da-element-id": "download_if", "data-da-priority": getPriorityNumber(numberOfButtonsBefore), slot: "start" }, labels.areaLabel)));
};

const provideQdsButtonAttributes = (numberOfButtonsBefore) => {
  const n = numberOfButtonsBefore;
  let attr;
  switch (n) {
    case 0:
      attr = { size: EQdsButtonSize.LARGE, importance: EQdsButtonImportance.EMPHASIZED };
      break;
    case 1:
      attr = { size: EQdsButtonSize.LARGE, importance: EQdsButtonImportance.STANDARD };
      break;
    default:
      attr = { size: EQdsButtonSize.STANDARD, importance: EQdsButtonImportance.SUBDUED };
  }
  return attr;
};
const SoftwareDownloadArea = ({ data, numberOfButtonsBefore = 0, className, ctaItem, position, }) => {
  const { labels, additionLinks } = data;
  if (additionLinks.length === 0)
    return;
  const isSubduedImportance = numberOfButtonsBefore === 2;
  if (additionLinks.length === 1) {
    const { url, type, target, reference, fileName, docType } = additionLinks[0];
    const attr = isTargetBlank(target) ? { target: '_blank' } : { download: '' };
    let icon;
    if (isLinkTypeOnline(type)) {
      icon = "arrow-top-right-on-square";
    }
    else if (isSubduedImportance) {
      icon = "arrow-down-tray";
    }
    return (h("qds-button", Object.assign({ class: className, href: url }, attr, provideQdsButtonAttributes(numberOfButtonsBefore), { onClick: () => onDownloadLinkClickGA(additionLinks[0], ctaItem, position), "data-da-element-id": "download_if", "data-da-priority": getPriorityNumber(numberOfButtonsBefore), "data-doc-reference": reference, "data-doc-name": fileName, "data-doc-type": docType, text: isLinkTypeOnline(type) ? labels.onlineLabel : labels.offlineLabel, iconName: icon, variant: "hero" })));
  }
  return (h("qds-button", Object.assign({ class: className }, provideQdsButtonAttributes(numberOfButtonsBefore), { onClick: () => onSoftwareDocumentDialogClick(additionLinks[0].type, additionLinks, labels, ctaItem, position), "data-da-element-id": "download_if", "data-da-priority": getPriorityNumber(numberOfButtonsBefore), text: labels.areaLabel, iconName: isSubduedImportance ? "square-behind-another" : '', variant: "hero" })));
};

const rangeCtaCss = ":host{display:block;box-sizing:border-box;margin-top:0;--qds-control-hero-border-radius:var(--qds-control-border-radius);--qds-control-hero-text:var(--qds-control-large-text);--qds-control-hero-gap-internal:var(--qds-control-large-gap-internal);--qds-control-hero-padding-auto-height:var(--qds-control-large-padding-auto-height);--qds-control-button-hero-padding-horizontal:var(--qds-control-button-large-padding-horizontal)}:host *,:host *::before,:host *::after{box-sizing:inherit}.cta-buttons-block{--qds-control-hero-border-radius:var(--qds-control-border-radius);--qds-control-hero-text:var(--qds-control-large-text);--qds-control-hero-gap-internal:var(--qds-control-large-gap-internal);--qds-control-hero-padding-auto-height:var(--qds-control-large-padding-auto-height);--qds-control-button-hero-padding-horizontal:var(--qds-control-button-large-padding-horizontal);display:flex;flex-direction:column;align-items:left;margin:21px 0 0 0}@media screen and (min-width: 720px){.cta-buttons-block{flex-direction:row;align-items:center}}.cta-links-block{--qds-control-hero-border-radius:var(--qds-control-border-radius);--qds-control-hero-text:var(--qds-control-standard-text);--qds-control-hero-gap-internal:var(--qds-control-standard-gap-internal);--qds-control-hero-padding-auto-height:var(--qds-control-standard-padding-auto-height);--qds-control-button-hero-padding-horizontal:var(--qds-control-button-standard-padding-horizontal);display:flex;flex-direction:column;align-items:flex-start;margin-top:27px}@media screen and (min-width: 720px){.cta-links-block{align-items:center;flex-direction:row;flex-wrap:wrap;align-items:center}:host(:not([dir=\"rtl\"])) .cta-links-block>.cta-element{margin:0 18px 0 0px}:host([dir=\"rtl\"]) .cta-links-block>.cta-element{margin:0 0px 0 18px}}.cta-section-space{margin-top:29px}.cta-element{margin:0 0 16px}@media screen and (min-width: 720px){:host(:not([dir=\"rtl\"])) .cta-element{margin:0 16px 0 0px}:host([dir=\"rtl\"]) .cta-element{margin:0 0px 0 16px}}.cta-element:last-child{margin:0}.range-cta-link{font-size:16px;line-height:1.5625}.range-cta-no-margin{width:100%;margin:0}.range-cta-link{font-size:16px;line-height:1.5625}.rangeCtaSec{display:flex;gap:8px;align-items:center;color:#42b4e6;cursor:pointer}.cta-software-dropdown-link{text-decoration:none}.cta-software-dropdown-button{border:none;width:100%;background:none;font-family:inherit;font-size:inherit;color:inherit;padding:0;margin:0;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;cursor:pointer}:host(:not([dir=\"rtl\"])) .cta-software-dropdown-button{text-align:left}:host([dir=\"rtl\"]) .cta-software-dropdown-button{text-align:right}.dropdownLink{text-decoration:none}.dropdown .rangeCtaSec{color:#333333}:host(:not([dir=\"rtl\"])) .dropdown .cta-element{padding-left:15px}:host([dir=\"rtl\"]) .dropdown .cta-element{padding-right:15px}@media screen and (max-width: 979px){.dropdown .cta-element{margin-bottom:0px}:host(:not([dir=\"rtl\"])) .dropdown .cta-element{padding-left:12px}:host([dir=\"rtl\"]) .dropdown .cta-element{padding-right:12px}}.dropdown .dropdown-cta{height:27px}@media screen and (max-width: 979px){.dropdown .dropdown-cta{margin-bottom:0px}:host(:not([dir=\"rtl\"])) .dropdown .dropdown-cta{padding-left:19px}:host([dir=\"rtl\"]) .dropdown .dropdown-cta{padding-right:19px}}.cta-dropdown{display:inline-block;box-sizing:unset}.product-selector-cta-link:hover{margin-bottom:2px;text-decoration:underline;text-underline-position:from-font}:host(:not([dir=\"rtl\"])) .product-selector-cta-icon{margin-left:4px}:host([dir=\"rtl\"]) .product-selector-cta-icon{margin-right:4px}";

const RangeCTA = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.productSelectorClick = createEvent(this, "productSelectorClick", 7);
    this.openProductSelector = (selector, item, position) => (_) => {
      if (this.selectorConfigResponse.config.type === 'sc') {
        const selectorModal = document.createElement('pdp-sc-selector-modal');
        const frame = document.createElement('div');
        frame.id = 'widgetFrame';
        selectorModal.headerLabel = this.selectorConfigResponse.config.scLabel || 'Select your product';
        selectorModal.appendChild(frame);
        selectorModal.open = true;
        selectorModal.addEventListener('didClose', () => {
          document.body.removeChild(selectorModal);
        });
        document.body.appendChild(selectorModal);
      }
      selector.open(this.updatedSelectorConfig(this.selectorConfig));
      addRangeClickGAEvent(item, position);
      send(productSelectorVirtualPageEvent);
    };
    this.openButtonLink = (item, position) => {
      addRangeClickGAEvent(item, position);
      window.open(item.url, item.target || '_self');
    };
    this.productSelectorClickHandler = (item, position) => {
      addRangeClickGAEvent(item, position);
      this.productSelectorClick.emit(true);
    };
    this.renderButton = (size, importance, iconName, position) => (item) => {
      return (h("qds-button", { size: size, importance: importance, class: "cta-element", block: true, onClick: () => this.openButtonLink(item, position), text: item.label, iconName: iconName, variant: "hero" }));
    };
    this.renderProductSelectorButton = (size, importance, iconName, position) => (item) => {
      return (this.selectorConfig && (h("pes-product-selector", { class: "cta-element", config: this.updatedSelectorConfig(this.selectorConfig), renderFunction: (selector) => (h("qds-button", { size: size, importance: importance, class: "cta-element", block: true, onClick: this.isExternalConsumer
            ? this.productSelectorClickHandler(item, position)
            : this.openProductSelector(selector, item, position), text: this.selectorConfigResponse.label, iconName: iconName, variant: "hero" })) })));
    };
    this.renderSoftwareDownloadDropdownItem = (numberOfButtonsBefore) => (item) => {
      return (h(CtaSoftwareDropdownItem, { additionLinks: item.data.additionLinks, labels: item.data.labels, numberOfButtonsBefore: numberOfButtonsBefore, ctaItem: item, position: RangeCTAPosition.OPTIONS }));
    };
    this.renderSoftwareDownloadArea = (numberOfButtonsBefore, position) => (item) => {
      return (h(SoftwareDownloadArea, { data: item.data, numberOfButtonsBefore: numberOfButtonsBefore, className: "cta-element", ctaItem: item, position: position }));
    };
    this.getProductSelectorForDropdown = () => {
      return (item) => {
        return (this.selectorConfig && (h("pes-product-selector", { config: this.updatedSelectorConfig(this.selectorConfig), renderFunction: (selector) => (h("se-list-item", null, h("button", { class: "cta-software-dropdown-button", onClick: this.openProductSelector(selector, item, RangeCTAPosition.OPTIONS), slot: "start" }, this.selectorConfigResponse.label))) })));
      };
    };
    this.renderDropdownItem = () => (item) => {
      const { url, target, label, type } = item;
      if (url) {
        return (h("a", { class: "dropdownLink", href: url, target: target, onClick: () => addRangeClickGAEvent(item, RangeCTAPosition.OPTIONS) }, h("se-list-item", { item: label })));
      }
      if (type === ADDITIONAL_CTA_LINKS) {
        return this.renderSoftwareDownloadDropdownItem(NUMBER_OF_BUTTONS_BEFORE)(item);
      }
      return this.getProductSelectorForDropdown()(item);
    };
    this.renderMap = {
      'notify-me': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "bell", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'contact-sales': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "check-writing-board", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'contact-support': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "chat-bubbles-square-ellipsis", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'external-product-selector': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, '', RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'buy-online': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "shopping-cart-arrow", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'request-demo': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "laptop-side", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'software-free-trial': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "screen-graph", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'ask-the-community': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "persons-small-big", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'talk-to-an-expert': {
        getEmphasized: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "person-writing-pad", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'sc-product-selector': {
        getEmphasized: this.renderProductSelectorButton(EQdsButtonSize.LARGE, EQdsButtonImportance.EMPHASIZED, '', RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderProductSelectorButton(EQdsButtonSize.LARGE, EQdsButtonImportance.STANDARD, '', RangeCTAPosition.STANDARD),
        getSubdued: this.renderProductSelectorButton(EQdsButtonSize.STANDARD, EQdsButtonImportance.SUBDUED, "squares-selected", RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
      'addition-links': {
        getEmphasized: this.renderSoftwareDownloadArea(0, RangeCTAPosition.EMPHASIZED),
        getStandard: this.renderSoftwareDownloadArea(1, RangeCTAPosition.STANDARD),
        getSubdued: this.renderSoftwareDownloadArea(2, RangeCTAPosition.SUBDUED),
        getDropdownLink: this.renderDropdownItem(),
      },
    };
    this.rangeCtas = [];
    this.moreOptionsLabel = undefined;
    this.getSelectorConfig = undefined;
    this.selectorConfigResponse = null;
    this.isExternalConsumer = undefined;
    this.selectorConfig = undefined;
    this.selectorExtraOptions = undefined;
  }
  componentWillLoad() {
    if (this.selectorConfigResponse) {
      this.configureSelector(this.selectorConfigResponse);
    }
    else if (this.getSelectorConfig) {
      this.getSelectorConfig()
        .then((response) => {
        this.selectorConfigResponse = response;
        this.configureSelector(response);
      })
        .catch(console.error);
    }
  }
  configureSelector(response) {
    this.selectorExtraOptions = updateProductCtasSelectorSettings(response, productCtas.buttons);
    this.selectorConfig = response === null || response === void 0 ? void 0 : response.config;
  }
  updatedSelectorConfig(config) {
    return deepMerge(config, { scOptions: this.selectorExtraOptions });
  }
  render() {
    const [primaryCta, secondaryCta, ...ctas] = this.rangeCtas;
    let dropDownCtas = [];
    let linksCtas = [];
    if (ctas.length > MAX_CTA_LIMIT) {
      dropDownCtas = ctas.splice(MAX_CTA_LIMIT);
    }
    linksCtas = ctas;
    return (h(Host, null, h("div", { class: "cta-buttons-block" }, primaryCta && this.renderMap[primaryCta.type].getEmphasized(primaryCta), secondaryCta && this.renderMap[secondaryCta.type].getStandard(secondaryCta)), (linksCtas === null || linksCtas === void 0 ? void 0 : linksCtas.length) > 0 && (h("div", { class: "cta-links-block" }, linksCtas.map((item) => { var _a, _b; return (_b = (_a = this.renderMap[item.type]) === null || _a === void 0 ? void 0 : _a.getSubdued) === null || _b === void 0 ? void 0 : _b.call(_a, item); }))), (dropDownCtas === null || dropDownCtas === void 0 ? void 0 : dropDownCtas.length) > 0 && (h(Fragment, null, h("div", { class: "cta-section-space" }), h("se-dropdown", { class: "cta-dropdown" }, h("se-button", { class: "drp-btn", slot: "trigger", "icon-color": "primary", option: "outline", size: "medium" }, this.moreOptionsLabel), h("se-list", { option: "dropdown" }, dropDownCtas.map((item) => {
      var _a, _b;
      return ((_b = (_a = this.renderMap[item.type]) === null || _a === void 0 ? void 0 : _a.getDropdownLink) === null || _b === void 0 ? void 0 : _b.call(_a, item));
    })))))));
  }
};
RangeCTA.style = rangeCtaCss;

const rangeInfoCss = ".range-info__container{background-color:#f7f7f7}@media screen and (min-width: 980px){.range-info__container{background-color:#ffffff}}.range-info{margin:0 auto}.range-info .highlight-naming{font-weight:400}.range-info .highlight-naming .accent{font-weight:700}@media screen and (max-width: 979px){.range-info{margin-bottom:22px}:host(:not([dir=\"rtl\"])) .range-info{margin-left:4px}:host([dir=\"rtl\"]) .range-info{margin-right:4px}}.range-info__cta-button-block{display:block}@media screen and (max-width: 979px){.range-info__cta-button-block{display:none}}@media screen and (min-width: 980px){.range-info__wrapper{display:flex}}.range-info__wrapper--desktop-only{display:none}@media screen and (min-width: 980px){.range-info__wrapper--desktop-only{display:flex}}.range-info__title{margin-top:0;margin-bottom:16px;line-height:2.8125rem;font-size:2.1875rem;font-weight:400;color:#333333}@media screen and (min-width: 980px){.range-info__title{line-height:3.125rem;font-size:2.625rem}}.range-info__slogan{color:#3dcd58;font-size:1.5625rem;font-weight:400;line-height:2.1875rem;margin-top:0;margin-bottom:16px}@media screen and (min-width: 980px){.range-info__slogan{font-size:1.875rem;line-height:2.5rem}}.range-info__description{color:#626469;font-size:1rem;line-height:1.5rem;margin-top:0;margin-bottom:5px}@media screen and (min-width: 980px){.range-info__description{font-size:1.125rem;line-height:1.875rem}}.range-info__image{display:block;text-align:center;flex-grow:1}.range-info__image img{width:190px;height:190px}@media screen and (min-width: 980px){.range-info__image img{width:260px;height:260px}}@media screen and (min-width: 980px){.range-info_software__image img{width:369px;height:369px}}.range-info__range-link{display:block;text-align:center;font-weight:700;font-size:0.8125rem;color:#42b4e6;text-decoration:none;position:relative}@media screen and (min-width: 980px){.range-info__range-link{display:none}}.range-info__range-link::before{content:\"<\";padding:5px}.range-info__mobile-title{margin:0;text-transform:capitalize;font-size:1.625rem;font-weight:100;line-height:1.625rem}@media screen and (min-width: 980px){.range-info__mobile-title{display:none}}.range-info .status-block{display:flex;flex-direction:column-reverse;margin:24px 0}@media screen and (min-width: 980px){.range-info .status-block{flex-direction:row;margin-bottom:10px}}.range-info .status-block__brand-logo{margin-bottom:12px}@media screen and (min-width: 980px){.range-info .status-block__brand-logo{margin-bottom:0;padding-top:4px}:host(:not([dir=\"rtl\"])) .range-info .status-block__brand-logo{margin-left:0}:host([dir=\"rtl\"]) .range-info .status-block__brand-logo{margin-right:0}}.range-info .status-block__brand-logo img{height:21px}.range-info__info div.status-block__brand-logo{margin-bottom:5px}@media screen and (max-width: 979px){.text-clamp{overflow:hidden;white-space:nowrap}.blurred-text{box-shadow:white 0px -19px 9px 11px;z-index:1;position:relative}.hide-in-mobile{transition:opacity 0.5s, display 0.5s;display:none}.commercial-status-mobile{display:block;padding:20px 0px 0px;margin:0px}}.btn-readmore{font-size:16px}@media screen and (min-width: 980px){.btn-readmore{display:none;animation:slideaway 200ms}.commercial-status-mobile{display:none}}.longDescription{display:inline}.longDescription a{display:inline-block;border-radius:var(--qds-focus-border-radius);box-sizing:border-box;text-decoration:underline;color:var(--qds-theme-link-standard-default)}.longDescription a:visited{color:var(--qds-theme-link-standard-visited)}.longDescription a:hover{color:var(--qds-theme-link-standard-hover)}.longDescription a:active{color:var(--qds-theme-link-standard-pressed)}.longDescription a:visited:hover{color:var(--qds-theme-link-standard-visited-hover)}.longDescription a:visited:active{color:var(--qds-theme-link-standard-visited-pressed)}.longDescription a[rel~=external]>.qds-external{display:inline-block}.longDescription a:focus-visible{outline:var(--qds-theme-focus-border) solid var(--qds-focus-border-width)}.longDescription a[aria-disabled=true]{opacity:var(--qds-theme-disabled);pointer-events:none}";

var RangeType;
(function (RangeType) {
  RangeType["SOFTWARE_FREE"] = "software_free";
  RangeType["SOFTWARE_PAID"] = "software_paid";
})(RangeType || (RangeType = {}));
const SoftwareRangeTypes = [RangeType.SOFTWARE_FREE, RangeType.SOFTWARE_PAID];
const RangeInfo$1 = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.image = undefined;
    this.name = undefined;
    this.description = undefined;
    this.masterRangeName = undefined;
    this.longDescription = undefined;
    this.rangePartofLabel = undefined;
    this.commercialStatus = undefined;
    this.brandLogo = undefined;
    this.rangeCtas = [];
    this.moreOptionsLabel = undefined;
    this.getSelectorConfig = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.learnMoreLabel = undefined;
    this.isExternalConsumer = undefined;
    this.rangeType = undefined;
    this.isVisible = false;
    this.isMobile = isMobile();
  }
  getWrapped(text) {
    return `<!--LONGDESC_BEGIN-->${text}<!--LONGDESC_END-->`;
  }
  changeVisibility() {
    this.isVisible = !this.isVisible;
  }
  learnMoreHandler() {
    document.dispatchEvent(new CustomEvent('activeOverview'));
  }
  render() {
    const isSoftwareRange = SoftwareRangeTypes.includes(this.rangeType);
    return (h("div", { class: "range-info" }, h("div", { class: classnames('range-info__wrapper') }, h("div", { class: "range-info__info" }, h("h1", { class: "range-info__title", innerHTML: this.name || '-' }), h("h2", { class: this.isVisible ? 'range-info__slogan' : 'range-info__slogan text-clamp', innerHTML: this.description }), h("div", { class: this.isVisible ? '' : 'blurred-text' }, ''), this.masterRangeName ? (h("p", { class: this.isVisible
        ? 'range-info__description'
        : 'range-info__description hide-in-mobile ', innerHTML: this.rangePartofLabel
        && this.rangePartofLabel.replace('#MasterRangeName#', this.masterRangeName) })) : null, h("div", { class: this.isVisible
        ? 'range-info__description'
        : 'range-info__description hide-in-mobile ' }, h("div", { class: "longDescription", innerHTML: this.getWrapped(this.longDescription) }), ' ', this.learnMoreLabel && (h("qds-button", { size: "standard", importance: "subdued", onClick: () => this.learnMoreHandler(), text: this.learnMoreLabel, iconName: "arrow-down" }))), h("div", { class: this.isVisible ? 'status-block' : 'hide-in-mobile' }, !this.isMobile
      && this.commercialStatus
      && this.commercialStatus.status !== ECommercialStatus.COMMERCIALIZED && (h("pes-badge-wrapper", { class: "card__badge card__additional-info-item", size: "large", type: this.commercialStatus.status, label: this.commercialStatus.label, color: this.commercialStatus.color })), this.brandLogo && (h("div", { class: "status-block__brand-logo" }, h("img", { src: this.brandLogo.url, alt: this.brandLogo.alt, fetchpriority: "high" })))), h("pes-range-cta", { class: "range-info__cta-button-block", rangeCtas: this.rangeCtas, getSelectorConfig: this.getSelectorConfig, isExternalConsumer: this.isExternalConsumer, moreOptionsLabel: this.moreOptionsLabel })), this.image && (h("div", { class: classnames('range-info__image', { 'hide-in-mobile': !this.isVisible, 'range-info_software__image': isSoftwareRange }) }, h("img", { src: this.image.url, alt: this.image.title, fetchpriority: "high" })))), h("div", { class: this.isVisible ? '' : 'blurred-text' }), h("qds-button", { size: "standard", importance: "subdued", class: "btn-readmore", action: this.isVisible ? 'dropdown-close' : 'dropdown', onClick: this.changeVisibility.bind(this), text: this.isVisible ? this.readLessLabel : this.readMoreLabel }), h("div", { class: "commercial-status-mobile" }, this.commercialStatus
      && this.commercialStatus.status !== ECommercialStatus.COMMERCIALIZED && (h("pes-badge-wrapper", { class: "card__badge card__additional-info-item", size: "large", type: this.commercialStatus.status, label: this.commercialStatus.label, color: this.commercialStatus.color })))));
  }
};
RangeInfo$1.style = rangeInfoCss;

const rangeMainCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.range-wrapper{background-color:#ffffff}@media screen and (min-width: 980px){.range-wrapper{padding:40px 0 49px}}@media screen and (max-width: 979px){.range-wrapper{padding:20px 16px 48px}}@media screen and (min-width: 980px){.range-main{width:100%;max-width:1200px;margin:0 auto}}.range-main-cta-button-block{display:block}@media screen and (min-width: 980px){.range-main-cta-button-block{display:none}}@media screen and (min-width: 980px){:host(.pesBusinessHeader) .range-main{width:auto;margin:20px auto 40px}}@media screen and (min-width: 980px){:host(.pesBusinessHeader) .range-wrapper{padding-right:8px;padding-left:8px;margin-right:auto;margin-left:auto}}";

const RangeMain = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.getSelectorConfig = () => getData(false, getSelectorConfigUrl(this.localeCode, this.id, this.isExternalConsumer));
    this.host = undefined;
    this.localeCode = undefined;
    this.endpoint = RANGE_ENDPOINT;
    this.rangePartofLabel = undefined;
    this.brandLogo = undefined;
    this.commercialStatus = undefined;
    this.description = undefined;
    this.id = undefined;
    this.image = undefined;
    this.longDescription = undefined;
    this.masterRangeName = undefined;
    this.name = undefined;
    this.rangeCtas = undefined;
    this.rangeId = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.learnMoreLabel = undefined;
    this.moreOptionsLabel = DEFAULT_CTA_DROPDOWN_LABEL;
    this.rangeType = undefined;
    this.requestRangeSelectorConfig = undefined;
    this.isExternalConsumer = undefined;
    this._host = undefined;
    this._localeCode = undefined;
    this._endpoint = undefined;
    this._rangePartofLabel = undefined;
    this._brandLogo = undefined;
    this._commercialStatus = undefined;
    this._description = undefined;
    this._id = undefined;
    this._image = undefined;
    this._longDescription = undefined;
    this._masterRangeName = undefined;
    this._name = undefined;
    this._rangeCtas = undefined;
    this._rangeId = undefined;
    this._readMoreLabel = undefined;
    this._readLessLabel = undefined;
    this._learnMoreLabel = undefined;
    this._moreOptionsLabel = undefined;
    this._rangeType = undefined;
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    window.scrollTo(0, 0);
    this.host = (_a = tryParse(this._host)) !== null && _a !== void 0 ? _a : this.host;
    this.localeCode = (_b = tryParse(this._localeCode)) !== null && _b !== void 0 ? _b : this.localeCode;
    this.endpoint = (_c = tryParse(this._endpoint)) !== null && _c !== void 0 ? _c : this.endpoint;
    this.rangePartofLabel = (_d = tryParse(this._rangePartofLabel)) !== null && _d !== void 0 ? _d : this.rangePartofLabel;
    this.brandLogo = (_e = tryParse(this._brandLogo)) !== null && _e !== void 0 ? _e : this.brandLogo;
    this.commercialStatus = (_f = tryParse(this._commercialStatus)) !== null && _f !== void 0 ? _f : this.commercialStatus;
    this.description = (_g = tryParse(this._description)) !== null && _g !== void 0 ? _g : this.description;
    this.id = (_h = tryParse(this._id)) !== null && _h !== void 0 ? _h : this.id;
    this.image = (_j = tryParse(this._image)) !== null && _j !== void 0 ? _j : this.image;
    this.longDescription = (_k = tryParse(this._longDescription)) !== null && _k !== void 0 ? _k : this.longDescription;
    this.masterRangeName = (_l = tryParse(this._masterRangeName)) !== null && _l !== void 0 ? _l : this.masterRangeName;
    this.name = (_m = tryParse(this._name)) !== null && _m !== void 0 ? _m : this.name;
    this.rangeCtas = (_o = tryParse(this._rangeCtas)) !== null && _o !== void 0 ? _o : this.rangeCtas;
    this.rangeId = (_p = tryParse(this._rangeId)) !== null && _p !== void 0 ? _p : this.rangeId;
    this.readMoreLabel = (_q = tryParse(this._readMoreLabel)) !== null && _q !== void 0 ? _q : this.readMoreLabel;
    this.readLessLabel = (_r = tryParse(this._readLessLabel)) !== null && _r !== void 0 ? _r : this.readLessLabel;
    this.learnMoreLabel = (_s = tryParse(this._learnMoreLabel)) !== null && _s !== void 0 ? _s : this.learnMoreLabel;
    this.moreOptionsLabel = (_t = tryParse(this._moreOptionsLabel)) !== null && _t !== void 0 ? _t : this.moreOptionsLabel;
    this.rangeType = (_u = tryParse(this._rangeType)) !== null && _u !== void 0 ? _u : this.rangeType;
  }
  render() {
    return (h("section", { class: "range-wrapper" }, h("div", { class: "range-main" }, h("pes-range-info", { image: this.image, name: this.name, description: this.description, masterRangeName: this.masterRangeName, longDescription: this.longDescription, rangePartofLabel: this.rangePartofLabel, commercialStatus: this.commercialStatus, brandLogo: this.brandLogo, rangeCtas: this.rangeCtas, getSelectorConfig: this.requestRangeSelectorConfig || this.getSelectorConfig, readMoreLabel: this.readMoreLabel, readLessLabel: this.readLessLabel, learnMoreLabel: this.learnMoreLabel, isExternalConsumer: this.isExternalConsumer, moreOptionsLabel: this.moreOptionsLabel, rangeType: this.rangeType }), h("pes-range-cta", { class: "range-main-cta-button-block", rangeCtas: this.rangeCtas, moreOptionsLabel: this.moreOptionsLabel, getSelectorConfig: this.requestRangeSelectorConfig || this.getSelectorConfig }))));
  }
};
RangeMain.style = rangeMainCss;

const rangeNodeCardCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.range-node-link{display:block;text-decoration:none}.range-node-link:hover{text-decoration:none}.range-node-link:visited{outline:none}.range-node-card{display:flex;flex-direction:column;align-items:center;width:280px;height:242px;border:1px solid #e7e6e6;background-color:#ffffff}.range-node-card:hover{text-decoration:none !important}.range-node-card:visited{outline:none !important}.range-node-card__img-wrapper{margin-top:30px}.range-node-card__img-wrapper img{width:140px;height:140px}.range-node-card__label-wrapper{align-self:flex-start}:host(:not([dir=\"rtl\"])) .range-node-card__label-wrapper{margin-left:30px}:host([dir=\"rtl\"]) .range-node-card__label-wrapper{margin-right:30px}.range-node-card__label{color:#626469;text-decoration:none}";

const RangeInfo = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.nodeSelected = createEvent(this, "nodeSelected", 7);
    this.image = undefined;
    this.name = undefined;
    this.id = undefined;
    this.url = undefined;
    this.nodeReference = undefined;
    this.nodes = undefined;
    this.navigationState = undefined;
    this.isPBS = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    var _a, _b;
    return (h("a", { href: !this.isPBS ? this.url : '#', class: "range-node-link", onClick: (event) => {
        if (this.isPBS) {
          event.preventDefault();
          this.nodeSelected.emit({
            id: this.id,
            image: this.image,
            url: this.url,
            name: this.name,
            nodeReference: this.nodeReference,
            nodes: this.nodes,
            navigationState: this.navigationState,
          });
        }
      } }, h("div", { class: "range-node-card" }, h("div", { class: "range-node-card__img-wrapper" }, h("img", { src: (_a = this.image) === null || _a === void 0 ? void 0 : _a.url, alt: (_b = this.image) === null || _b === void 0 ? void 0 : _b.alt })), h("div", { class: "range-node-card__label-wrapper" }, h("p", { class: "range-node-card__label" }, this.name)))));
  }
  get el() { return getElement(this); }
};
RangeInfo.style = rangeNodeCardCss;

const rangeNodesCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.range-nodes-list{display:flex;flex-wrap:wrap;list-style-type:none;margin:24px 0 0;padding:0;overflow-y:hidden}@media screen and (max-width: 979px){.range-nodes-list{flex-direction:column}}.range-nodes-list__item{margin-bottom:20px}:host(:not([dir=\"rtl\"])) .range-nodes-list__item:not(:last-child){margin-right:20px}:host([dir=\"rtl\"]) .range-nodes-list__item:not(:last-child){margin-left:20px}@media screen and (max-width: 979px){.range-nodes-list__item:not(:last-child){margin-bottom:20px}:host(:not([dir=\"rtl\"])) .range-nodes-list__item:not(:last-child){margin-right:auto}:host([dir=\"rtl\"]) .range-nodes-list__item:not(:last-child){margin-left:auto}}:host(:not([dir=\"rtl\"])) .range-nodes-list__item:nth-child(4n){margin-right:0}:host([dir=\"rtl\"]) .range-nodes-list__item:nth-child(4n){margin-left:0}@media screen and (max-width: 979px){:host(:not([dir=\"rtl\"])) .range-nodes-list__item:nth-child(4n){margin-right:auto}:host([dir=\"rtl\"]) .range-nodes-list__item:nth-child(4n){margin-left:auto}}@media screen and (max-width: 979px){.range-nodes-list__item{margin:0 auto}}";

const RangeNodes = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.backUrl = undefined;
    this.backUrlTitle = undefined;
    this.levelTitle = undefined;
    this.childrenNodes = undefined;
    this.isPBS = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  nodeUrlWithParameters(url) {
    const hash = window.location.hash.substring(1);
    return addParameterToLink(url, {
      filter: getQueryParam('filter'),
    }, hash);
  }
  render() {
    var _a;
    return (h(Host, null, this.backUrl && (h("pes-range-node-header", { backUrl: this.backUrl, backUrlTitle: this.backUrlTitle, levelTitle: this.levelTitle, isPBS: this.isPBS })), ((_a = this.childrenNodes) === null || _a === void 0 ? void 0 : _a.length) > 0 && (h("ul", { class: "range-nodes-list" }, this.childrenNodes.map((node) => (h("li", { class: "range-nodes-list__item", key: node.id }, h("pes-range-node-card", { image: node.image, url: this.nodeUrlWithParameters(node.url), name: node.name, id: node.id, nodes: node.nodes, nodeReference: node.nodeReference, isPBS: this.isPBS, navigationState: node.navigationState }))))))));
  }
  get el() { return getElement(this); }
};
RangeNodes.style = rangeNodesCss;

const rangePresentationTabCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}.range-presentation-tab{display:flex;margin:0 auto;padding:20px 7px 48px}@media screen and (min-width: 980px){.range-presentation-tab{padding:0 0 98px}}.range-presentation-tab ul{padding:0 0 12px}.range-presentation-tab ul li{list-style:disc inside;text-indent:0;margin-bottom:15px;color:#626469;font-size:0.8125rem;font-weight:400;line-height:1.21875rem}.range-presentation-tab p{color:#626469;font-size:0.8125rem;font-weight:400;line-height:1.21875rem}.range-presentation-tab a{display:inline-block;border-radius:var(--qds-focus-border-radius);box-sizing:border-box;text-decoration:underline;color:var(--qds-theme-link-standard-default)}.range-presentation-tab a:visited{color:var(--qds-theme-link-standard-visited)}.range-presentation-tab a:hover{color:var(--qds-theme-link-standard-hover)}.range-presentation-tab a:active{color:var(--qds-theme-link-standard-pressed)}.range-presentation-tab a:visited:hover{color:var(--qds-theme-link-standard-visited-hover)}.range-presentation-tab a:visited:active{color:var(--qds-theme-link-standard-visited-pressed)}.range-presentation-tab a[rel~=external]>.qds-external{display:inline-block}.range-presentation-tab a:focus-visible{outline:var(--qds-theme-focus-border) solid var(--qds-focus-border-width)}.range-presentation-tab a[aria-disabled=true]{opacity:var(--qds-theme-disabled);pointer-events:none}.range-presentation-tab strong{line-height:2.125rem}.range-presentation-tab table{width:100%}.range-presentation-tab__additional-links{display:grid;grid-template-columns:1fr 1fr 1fr;align-items:baseline}@media screen and (min-width: 720px) and (max-width: 980px){.range-presentation-tab__additional-links{grid-template-columns:1fr 1fr}}@media screen and (max-width: 719px){.range-presentation-tab__additional-links{grid-template-columns:1fr}}.range-presentation-tab__additional-link{padding:20px 15px}.range-presentation-tab__more-features{margin-top:20px}.list-images{display:flex;flex-wrap:wrap;justify-content:space-between}@media screen and (min-width: 980px){.list-images{justify-content:start}}.list-images__image{width:100%}.list-images li.list-images__image-wrapper{max-width:calc(50% - 20px);list-style:none;display:list-item;flex-direction:column;margin:0;padding:0;border-bottom:40px solid transparent}@media screen and (min-width: 980px){.list-images li.list-images__image-wrapper{width:196px;justify-content:start;border-bottom:40px solid transparent;border-left:20px solid transparent;border-right:20px solid transparent}}.range-presentation-tab__article+.range-presentation-tab__article{border-top:solid 1px #e6e6e6;margin-top:27px}.range-presentation-tab__article__header,.range-presentation-tab__article h3{font-size:2.5rem;color:#3dcd58;line-height:1.5em;font-weight:400;text-align:center}@media screen and (max-width: 979px){.range-presentation-tab__article__header,.range-presentation-tab__article h3{margin:0 0 20px}}@media screen and (min-width: 980px){.range-presentation-tab__article__header,.range-presentation-tab__article h3{text-align:left;margin:0 0 15px}}.range-presentation-tab__article iframe{max-width:100%}.range-presentation-tab__sdl-content{box-sizing:border-box}.range-presentation-tab__sdl-content *,.range-presentation-tab__sdl-content *::before,.range-presentation-tab__sdl-content *::after{box-sizing:inherit}@media screen and (max-width: 979px){.range-presentation-tab__sdl-content{margin-top:20px}}@media screen and (min-width: 980px){.range-presentation-tab__sdl-content{margin-top:40px}}.range-presentation-tab__sdl-content a:hover{text-decoration:underline}";

const RangePresentationTab = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.presentation = undefined;
    this.isSlotAvailable = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  renderMoreFeatures() {
    if (this.presentation.presentation2) {
      return (h("div", { class: "range-presentation-tab__more-features", innerHTML: this.presentation.presentation2 }));
    }
  }
  renderArticle({ label, content = '', extraLayout = '' }) {
    if (label && (content || extraLayout)) {
      return (h("article", { class: "range-presentation-tab__article" }, h("h3", { class: "range-presentation-tab__article-header" }, label), content && h("div", { class: "range-presentation-tab__article-content", innerHTML: content }), extraLayout));
    }
  }
  getWrapped(text, type) {
    switch (type) {
      case 'b':
        return `<!--BENEFITS_BEGIN-->${text}<!--BENEFITS_END-->`;
      case 'f':
        return `<!--PRESENTATION_BEGIN-->${text}<!--PRESENTATION_END-->`;
      case 'a':
        return `<!--APPLICATIONS_BEGIN-->${text}<!--APPLICATIONS_END--> `;
      default:
        return text;
    }
  }
  renderBenefits() {
    if (this.presentation.benefits) {
      return this.renderArticle({
        label: this.presentation.rangePresentationBenefitsLabel,
        content: this.getWrapped(this.presentation.benefits, 'b'),
      });
    }
  }
  renderFeatures() {
    if (this.presentation.presentation1 || this.presentation.presentation2) {
      return this.renderArticle({
        label: this.presentation.rangePresentationFeaturesLabel,
        content: this.getWrapped(this.presentation.presentation1, 'f'),
        extraLayout: this.renderMoreFeatures(),
      });
    }
  }
  renderApplications() {
    if (this.presentation.rangeApplication) {
      return this.renderArticle({
        label: this.presentation.rangePresentationApplicationsLabel,
        content: this.getWrapped(this.presentation.rangeApplication, 'a'),
      });
    }
  }
  renderGallery() {
    if (this.presentation.images && this.presentation.images.length) {
      const extraLayout = (h("ul", { class: "list-images" }, this.presentation.images.map((i) => (h("li", { class: "list-images__image-wrapper" }, h("img", { class: "list-images__image", src: i.url, alt: i.title }))))));
      return this.renderArticle({ label: this.presentation.rangeGaleryLabel, extraLayout });
    }
  }
  renderAdditionalLinks() {
    if (this.presentation.additionalLinks && this.presentation.additionalLinks.length) {
      const extraLayout = (h("div", { class: "range-presentation-tab__additional-links" }, this.presentation.additionalLinks.map((link) => (h("div", null, h("qds-standalone-link", { size: "standard", importance: "standard", href: link.url, target: link.target, class: "range-presentation-tab__additional-link" }, link.label))))));
      return this.renderArticle({
        label: this.presentation.rangeAdditionalLinksLabel,
        extraLayout,
      });
    }
  }
  componentDidRender() {
    if (this.presentation.sdlContent) {
      pasteScripts(this.el, '.overview-sdl-content');
    }
  }
  componentWillLoad() {
    const slot = this.el.querySelector('slot');
    if (!slot)
      return;
    this.isSlotAvailable = slot.assignedNodes({ flatten: true }).length > 0;
  }
  render() {
    if (this.isSlotAvailable) {
      return (h("div", { class: "overview-sdl-content range-presentation-tab__sdl-content" }, h("slot", null)));
    }
    if (this.presentation.sdlContent) {
      try {
        return (h("div", { class: "overview-sdl-content range-presentation-tab__sdl-content", innerHTML: decodeFromURI(this.presentation.sdlContent) }));
      }
      catch (error) {
        console.log(error);
      }
    }
    return (h("div", { class: "range-presentation-tab" }, h("div", null, this.renderFeatures(), this.renderBenefits(), this.renderApplications(), this.renderGallery(), this.renderAdditionalLinks())));
  }
  get el() { return getElement(this); }
};
RangePresentationTab.style = rangePresentationTabCss;

const rangeProductsTabCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}.range-products-tab{position:relative}@media screen and (max-width: 979px){.range-products-tab{display:block;padding-bottom:24px}}@media screen and (min-width: 980px){.range-products-tab{display:flex;flex-direction:column;overflow:visible;padding-bottom:48px}}.range-products-tab__nodes-wrapper{padding-top:32px}.range-products-tab__main-block-container{display:flex;flex-direction:column}@media screen and (min-width: 980px){.range-products-tab__main-block-container{flex-direction:row}}@media screen and (max-width: 979px){.range-products-tab__products-count{color:#626469;font-size:14px;line-height:20px;margin-bottom:12px}}@media screen and (min-width: 980px){.range-products-tab__products-count{display:none}}.range-products-tab__products{padding-top:24px;position:relative}@media screen and (min-width: 980px){.range-products-tab__products{padding-top:36px}}.range-products-tab__products--desktop{display:none}@media screen and (min-width: 980px){.range-products-tab__products--desktop{display:initial;overflow:visible}}@media screen and (min-width: 980px){.range-products-tab__products-list{display:block}:host(:not([dir=\"rtl\"])) .range-products-tab__products-list{margin-left:20px}:host([dir=\"rtl\"]) .range-products-tab__products-list{margin-right:20px}}.range-products-tab__overlay{z-index:2;top:0;right:0;bottom:0;left:0;background:#fafafa;opacity:0.4}.range-products-tab__overlay:not(.range-products-tab__overlay--visible){display:none}@media screen and (max-width: 979px){.range-products-tab__overlay{position:fixed}}@media screen and (min-width: 980px){.range-products-tab__overlay{position:absolute}}.range-products-tab__desktop-pagination{width:100%;text-align:center;margin-top:36px}@media screen and (max-width: 979px){.range-products-tab__desktop-pagination{display:none}}.range-products-tab__load-prev-btn{margin-bottom:20px}.range-products-tab__load-more-btn{margin-top:20px}@media screen and (min-width: 980px){.range-products-tab__load-prev-btn,.range-products-tab__load-more-btn{display:none}}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .range-products-tab__rich-text{margin-left:20px}:host([dir=\"rtl\"]) .range-products-tab__rich-text{margin-right:20px}}@media screen and (min-width: 980px){.range-products-tab__filters{padding-top:36px;max-width:280px}}";

const RangeProductsTab = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.pageSelected = createEvent(this, "pageSelected", 7);
    this.handleComparatorChange = (e) => {
      this.comparatorValue = e.detail;
    };
    this.onPaginationChange = (event) => {
      const pageNumber = event.detail.value;
      send(paginationClickEvent, { articleTitle: pageNumber });
      this.pageSelected.emit(pageNumber);
      scrollToTop(this.el);
    };
    this.loadPrevious = () => {
      const previousPageNumber = Math.floor(this.firstLoadedRecNum / this.productsPerPage);
      send(paginationClickEvent, { articleTitle: previousPageNumber });
      this.pageSelected.emit(previousPageNumber);
      this.scrollToProduct = this.productsPerPage;
    };
    this.loadMore = () => {
      const nextPageNumber = Math.floor(this.lastLoadedRecNum / this.productsPerPage) + 1;
      send(paginationClickEvent, { articleTitle: nextPageNumber });
      this.pageSelected.emit(nextPageNumber);
      this.scrollToProduct = this.lastLoadedRecNum - this.firstLoadedRecNum + 1;
    };
    this.handleProductCtasChange = (event) => {
      if (!this.productCtas)
        return;
      if (this.isPBS) {
        this.productCtas = Object.assign({}, this.productCtas);
        return;
      }
      this.productCtas = Object.assign(Object.assign({}, this.productCtas), { buttons: event.detail });
    };
    this.labels = undefined;
    this.hostWithLocale = undefined;
    this.host = undefined;
    this.currentNode = undefined;
    this.name = undefined;
    this.filters = undefined;
    this.filtrationSmartData = undefined;
    this.navigationState = undefined;
    this.productList = undefined;
    this.productUrlParams = undefined;
    this.pills = undefined;
    this.categories = undefined;
    this.productsPerPage = undefined;
    this.productsCount = undefined;
    this.selectedPage = undefined;
    this.isLoading = undefined;
    this.isMobileCategorySelected = undefined;
    this.siteType = undefined;
    this.isPBS = undefined;
    this.localeCode = undefined;
    this.id = undefined;
    this.showDocuments = undefined;
    this.resultCount = undefined;
    this.firstLoadedRecNum = undefined;
    this.lastLoadedRecNum = undefined;
    this.productCtas = {
      buttons: {
        [productCtasButtonType.CART]: {
          isShown: false,
          list: [],
          color: productCtasColors.PRIMARY_BLUE,
          icons: {
            addIcon: "shopping-cart",
            disableIconInPdpCtaBlock: true,
          },
          dataset: {
            daElementId: 'add_p',
          },
          labels: {},
        },
        [productCtasButtonType.FAVORITES]: {
          isShown: false,
          list: [],
          color: productCtasColors.SECONDARY_BLUE,
          icons: {
            addIcon: "star",
            removeIcon: "star-filled",
          },
          dataset: {
            daElementId: 'add_p',
          },
          labels: {},
        },
      },
      productProp: 'repositoryId',
    };
    this.richText = undefined;
    this.enableCommerceConnector = undefined;
    this.showBuyOnline = true;
    this.selectedSectionsCount = undefined;
    this.showCompare = true;
    this.enableAppRouting = false;
    this.isExternalConsumer = undefined;
    this.externalUrlConfig = undefined;
    this.externalFavoriteConfig = undefined;
    this.analyticsPageData = undefined;
    this.isFilterMobileViewVisible = false;
    this.isMobileView = false;
    this.scrollToProduct = undefined;
    this.comparatorValue = comparator.value;
    this.productCtasState = this.productCtas;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  windowSizeDidChange() {
    if (!isMobile() && this.isFilterMobileViewVisible === true) {
      this.isFilterMobileViewVisible = false;
    }
    this.isMobileView = isMobile();
  }
  connectedCallback() {
    window.addEventListener(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.handleComparatorChange);
  }
  disconnectedCallback() {
    window.removeEventListener(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.handleComparatorChange);
  }
  componentWillLoad() {
    this.isMobileView = isMobile();
  }
  productCtasDidChange(newProductCtas) {
    this.productCtasState = Object.assign({}, newProductCtas);
  }
  get productIds() {
    return this.productList;
  }
  get totalPages() {
    return Math.ceil(this.productsCount / this.productsPerPage);
  }
  getAdditionalMainQueryParams() {
    return { nodeOrSubCatId: this.navigationState, isCategoryListing: false };
  }
  renderProductCardsWrapper() {
    var _a, _b, _c;
    return (h("product-cards-wrapper", { showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, showCompare: this.showCompare, comparator: this.comparatorValue, enableCommerceConnector: this.enableCommerceConnector, "product-ids": this.productIds, host: this.host, hostWithLocale: this.hostWithLocale, class: "range-products-tab__products-list", productCtas: this.productCtas, productOfProductsLabel: this.labels.numberProductsOfAllProductsLabel, productsLabel: this.labels.appProductsLabel, productUrlParams: this.productUrlParams, firstRecNum: (_a = this.resultCount) === null || _a === void 0 ? void 0 : _a.firstRecNum, lastRecNum: (_b = this.resultCount) === null || _b === void 0 ? void 0 : _b.lastRecNum, totalNumRecs: (_c = this.resultCount) === null || _c === void 0 ? void 0 : _c.totalNumRecs, areListGridLabelsShown: false, scrollToProduct: this.scrollToProduct, siteType: this.siteType, enableAppRouting: this.enableAppRouting, additionalMainQueryParams: this.getAdditionalMainQueryParams(), localeCode: this.localeCode, isExternalConsumer: this.isExternalConsumer, externalUrlConfig: this.externalUrlConfig, externalFavoriteConfig: this.externalFavoriteConfig, currentPageStorageKey: `${RANGE}/${this.id}`, isProductListing: true, analyticsPageData: this.analyticsPageData }, h("div", { slot: "pills" }, h("pes-range-filter-pills", { pills: this.pills }))));
  }
  onToggleFilterMobileViewVisibility() {
    this.isFilterMobileViewVisible = !this.isFilterMobileViewVisible;
  }
  renderNodes() {
    return (h("se-block", { color: "none", class: "range-products-tab__nodes-wrapper" }, h("pes-range-nodes", { backUrl: this.currentNode.backUrl, backUrlTitle: this.currentNode.backUrlTitle, levelTitle: this.currentNode.levelTitle, childrenNodes: this.currentNode.childrenNodes, isPBS: this.isPBS })));
  }
  renderFilters() {
    return this.filtrationSmartData ? (h("pes-responsive-filters", { class: "range-products-tab__filters", filtrationSmartData: this.filtrationSmartData, resetButtonLabel: this.labels.facetButtonResetAllLabel, viewMoreFacetsLabel: this.labels.facetButtonViewMoreFilters, viewLessFacetsLabel: this.labels.facetButtonViewLessFilters, headerLabelDesktop: this.labels.commonFiltersFilterBy, headerLabelMobile: this.labels.rangeProductsFiltersLabel, viewProductsLabel: this.labels.viewProductsLabel, viewMoreRefinementsLabel: this.labels.viewMoreLabel, viewLessRefinementsLabel: this.labels.viewLessLabel, isMobileViewVisible: this.isFilterMobileViewVisible, isMobileCategorySelected: this.isMobileCategorySelected, selectedSectionsCount: this.selectedSectionsCount, productsCount: this.productsCount, categories: this.categories, onShowMobileFilter: () => (this.isFilterMobileViewVisible = true) })) : null;
  }
  renderProducts() {
    var _a, _b, _c, _d;
    return (h("se-block", { direction: "row", color: "standard", class: classnames('range-products-tab__products', 'range-products-tab__main-block-wrapper', {
        'range-products-tab__products--desktop': this.isFilterMobileViewVisible
          || (((_a = this.categories) === null || _a === void 0 ? void 0 : _a.length) !== 0 && !this.isMobileCategorySelected),
      }) }, this.isMobileCategorySelected && (h("div", { class: "range-products-tab__products-count" }, this.labels.rangeProductLabel, ": ", this.productsCount)), this.productList && this.isMobileCategorySelected && this.firstLoadedRecNum > 1 && (h("qds-button", { size: EQdsButtonSize.LARGE, importance: EQdsButtonImportance.STANDARD, class: "range-products-tab__load-prev-btn", onClick: this.loadPrevious, text: this.labels.loadPreviousLabel })), h("pes-rich-text-information", { richText: this.richText, class: "range-products-tab__rich-text" }), h("pes-range-product-ctas-updater", { buttons: (_b = this.productCtas) === null || _b === void 0 ? void 0 : _b.buttons, myProductsGetter: getMyProductsFromConnector, onButtonsChange: this.handleProductCtasChange }), ((_c = this.productList) === null || _c === void 0 ? void 0 : _c.length) > 0 || this.isLoading
      ? this.renderProductCardsWrapper()
      : !((_d = this.richText) === null || _d === void 0 ? void 0 : _d.length) && (h("pes-filters-no-results", { noResultsClearLink: this.labels.noResultsClearLink, noResultsHeader: this.labels.noResultsHeader, noResultsMessage: this.labels.noResultsMessage })), this.productList && this.productsCount > this.productsPerPage && (h("se-pagination", { hideEdge: true, perPage: this.productsPerPage, total: this.totalPages, value: this.selectedPage, labelValue: this.labels.labelValue, labelPrev: this.labels.previousLabel, labelNext: this.labels.nextLabel, onDidChange: this.onPaginationChange, class: "range-products-tab__desktop-pagination" })), this.productList
      && this.isMobileCategorySelected
      && this.lastLoadedRecNum < this.productsCount && (h("qds-button", { size: EQdsButtonSize.LARGE, importance: EQdsButtonImportance.STANDARD, class: "range-products-tab__load-more-btn", onClick: this.loadMore, text: this.labels.loadMoreLabel }))));
  }
  render() {
    var _a, _b;
    return (h(Fragment, null, h("se-container", { color: "standard", class: "range-products-tab" }, h("div", { class: {
        'range-products-tab__overlay': true,
        'range-products-tab__overlay--visible': this.isLoading,
      } }), ((_a = this.currentNode) === null || _a === void 0 ? void 0 : _a.showNodes) && this.renderNodes(), ((_b = this.currentNode) === null || _b === void 0 ? void 0 : _b.showProducts) && (h("div", { class: "range-products-tab__main-block-container" }, this.renderFilters(), this.renderProducts())))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "productCtas": ["productCtasDidChange"]
  }; }
};
RangeProductsTab.style = rangeProductsTabCss;

const rangeSoftwareRegistrationTabCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.range-software-registration{position:relative;height:0;padding:30px 0 65%;overflow:hidden;margin:0 auto}.range-software-registration__iframe{border:1px solid #ededed;position:absolute;top:0;width:100%;height:100%;margin-top:25px}:host(:not([dir=\"rtl\"])) .range-software-registration__iframe{left:0}:host([dir=\"rtl\"]) .range-software-registration__iframe{right:0}";

const RangeSoftwareRegistrationTab = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.url = undefined;
  }
  render() {
    return (h("div", { class: "range-software-registration" }, h("iframe", { class: "range-software-registration__iframe", src: this.url })));
  }
};
RangeSoftwareRegistrationTab.style = rangeSoftwareRegistrationTabCss;

const rangeWebinarsAndResourcesTabCss = ".range-webinars-and-resources-tab__sdl-content{box-sizing:border-box}.range-webinars-and-resources-tab__sdl-content *,.range-webinars-and-resources-tab__sdl-content *::before,.range-webinars-and-resources-tab__sdl-content *::after{box-sizing:inherit}@media screen and (max-width: 979px){.range-webinars-and-resources-tab__sdl-content{margin-top:20px}}@media screen and (min-width: 980px){.range-webinars-and-resources-tab__sdl-content{margin-top:40px}}.range-webinars-and-resources-tab__sdl-content a:hover{text-decoration:underline}";

const RangeWebinarsAndResourcesTab = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.webinarAndResources = undefined;
  }
  render() {
    return (h("div", { class: "webinars-and-resources-sdl-content range-webinars-and-resources-tab__sdl-content" }, h("pes-sdl-content", { sdlHtmlContent: this.webinarAndResources.sdlContent })));
  }
  get el() { return getElement(this); }
};
RangeWebinarsAndResourcesTab.style = rangeWebinarsAndResourcesTabCss;

const sdlContentCss = ".sdl-content--ecostruxure{padding-bottom:22px;background-color:#ffffff}";

const SDLContent = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.getTabType = (sdlComponentId) => {
      switch (sdlComponentId) {
        case 'ecostruxure':
          return ETabType.ECOSTRUXURE;
        default:
          return null;
      }
    };
    this.sdlHtmlContent = undefined;
    this.sdlComponentId = undefined;
    this._sdlHtmlContent = undefined;
    this._sdlComponentId = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  handleTabClicked(event) {
    if (this.el && event.detail.type === this.getTabType(this.sdlComponentId)) {
      scrollToComponent(this.el);
    }
  }
  componentWillLoad() {
    var _a, _b;
    this.sdlHtmlContent = (_a = tryParse(this._sdlHtmlContent)) !== null && _a !== void 0 ? _a : this.sdlHtmlContent;
    this.sdlComponentId = (_b = tryParse(this._sdlComponentId)) !== null && _b !== void 0 ? _b : this.sdlComponentId;
  }
  componentDidRender() {
    if (this.sdlHtmlContent) {
      pasteScripts(this.el, '.sdl-content');
    }
  }
  render() {
    this.el.innerHTML = '';
    if (this.sdlHtmlContent) {
      try {
        return (h("div", { class: {
            'sdl-content': true,
            'sdl-content--ecostruxure': this.sdlComponentId === 'ecostruxure',
          }, innerHTML: decodeFromURI(this.sdlHtmlContent) }));
      }
      catch (error) {
        console.log(error);
      }
    }
    return null;
  }
  get el() { return getElement(this); }
};
SDLContent.style = sdlContentCss;

const pesSprykerRangeTabsCss = ":host{display:block;box-sizing:border-box;--document-listing-top-margin:0;--document-listing-top-margin-mobile:0}:host *,:host *::before,:host *::after{box-sizing:inherit}.range-tabs{width:100%;height:100%}pes-document-listing .document-listing-container{background:transparent;box-sizing:border-box}pes-document-listing .document-listing-container *,pes-document-listing .document-listing-container *::before,pes-document-listing .document-listing-container *::after{box-sizing:inherit}";

const RangeTabs = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.handlePopState = () => {
      var _a, _b;
      if (this.isPBS)
        return;
      const { offset, productsPerPage } = this.getPaginationParamsWithDefaults;
      this.selectedPage = Math.floor(offset / productsPerPage) + 1;
      const changedFilterUrl = getRangeFilterUrl(this.filterNodeId, (_b = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.filtersUrl, this.localeCode);
      this.nodeOrSubCatId = getSelectedNodeIdFromUrl(this.initialNodeId);
      this.loadFilters(changedFilterUrl);
    };
    this.renderPresentationTab = (slot = null) => {
      var _a;
      if (!((_a = this.tabs) === null || _a === void 0 ? void 0 : _a.presentation))
        return null;
      return (h("pes-range-presentation-tab", { presentation: this.tabs.presentation }, slot));
    };
    this.renderWebinarsAndResources = () => {
      var _a;
      return (((_a = this.tabs) === null || _a === void 0 ? void 0 : _a.webinarsAndResources) && (h("pes-range-webinars-and-resources-tab", { webinarAndResources: this.tabs.webinarsAndResources })));
    };
    this.renderProductsTab = () => (h("pes-range-products-tab", { labels: {
        commonFiltersFilterBy: this.commonFiltersFilterBy,
        facetButtonResetAllLabel: this.facetButtonResetAllLabel,
        rangeProductsFiltersLabel: this.rangeProductsFiltersLabel,
        facetButtonViewMoreFilters: this.facetButtonViewMoreFilters,
        facetButtonViewLessFilters: this.facetButtonViewLessFilters,
        previousLabel: this.previousLabel,
        nextLabel: this.nextLabel,
        labelValue: this.pageLabel,
        viewProductsLabel: this.viewProductsLabel,
        rangeProductLabel: this.rangeProductLabel,
        appProductsLabel: this.appProductsLabel,
        numberProductsOfAllProductsLabel: this.numberProductsOfAllProductsLabel,
        noResultsClearLink: this.noResultsClearLink,
        noResultsHeader: this.noResultsHeader,
        noResultsMessage: this.noResultsMessage,
        viewMoreLabel: this.viewMoreLabel,
        viewLessLabel: this.viewLessLabel,
        loadMoreLabel: this.loadMoreLabel,
        loadPreviousLabel: this.loadPreviousLabel,
      }, hostWithLocale: this.isPBS ? this.hostWithLocale : this.localeCode, host: this.host, name: this.name, currentNode: this.currentNode, filters: this.filters, filtrationSmartData: this.filtrationSmartData, navigationState: this.nodeOrSubCatId, productList: this.products.map((productInfo) => productInfo).join(), productUrlParams: this.productUrlParams || '', pills: this.pills, categories: this.filtersCategories, productsPerPage: this.getPaginationParamsWithDefaults.productsPerPage, productsCount: this.productsCount, selectedPage: this.selectedPage, isLoading: this.isLoading, isMobileCategorySelected: this.isMobileCategorySelected, showDocuments: this.showDocuments, resultCount: this.resultsCount, firstLoadedRecNum: this.firstLoadedRecNum, lastLoadedRecNum: this.lastLoadedRecNum, richText: this.richText, enableCommerceConnector: this.enableCommerceConnector, showBuyOnline: this.showBuyOnline, selectedSectionsCount: this.selectedSectionsCount, productCtas: this.productCtas, showCompare: !this.isPBS, isPBS: this.isPBS, enableAppRouting: this.isExternalConsumer ? !this.externalAppRoutingEnabled : this.isPBS, isExternalConsumer: this.isExternalConsumer, externalUrlConfig: this.externalUrlConfig, externalFavoriteConfig: this.externalFavoriteConfig, localeCode: this.localeCode, id: this.id, analyticsPageData: this.analyticsPageData }));
    this.renderDocumentListing = (name, isSoftware) => {
      var _a, _b, _c, _d, _e;
      return (!isEmpty_1(this.tabs.documents) && (h("pes-document-listing", { name: name, apiEndpoint: this.tabs.documents.apiEndpoint, documentDetailsUrl: this.tabs.documents.documentDetailsUrl, enableDocumentDetailsUrl: false, country: getCountry(this.localeCode), language: getLanguage(this.localeCode), pageType: "range", resourceId: this.id, software: isSoftware, view: "smallcard", myFavorites: false, applicationSource: ((_a = this.documentListing) === null || _a === void 0 ? void 0 : _a.appSource) || ((_c = (_b = this.tabs) === null || _b === void 0 ? void 0 : _b.documents) === null || _c === void 0 ? void 0 : _c.appSource), userProfile: (_d = this.documentListing) === null || _d === void 0 ? void 0 : _d.userProfile, idmsToken: (_e = this.documentListing) === null || _e === void 0 ? void 0 : _e.idmsToken })));
    };
    this.renderSoftwareRegistration = () => {
      return (!isEmpty_1(this.tabs.softwareRegistration) && (h("pes-range-software-registration-tab", { url: this.tabs.softwareRegistration.softwareRegistrationUrl })));
    };
    this.getTabRenderInfoByNames = (tabName) => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      const productsTab = {
        title: (_b = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.title,
        renderFunction: this.renderProductsTab,
        hash: TAB_NAMES.Products,
        hidden: false,
      };
      switch (tabName) {
        case 'products': return ((_d = (_c = this.tabs) === null || _c === void 0 ? void 0 : _c.products) === null || _d === void 0 ? void 0 : _d.showProductsTab) ? productsTab : null;
        case 'presentation': return {
          title: this.rangePresentationLabel,
          renderFunction: (slot) => this.renderPresentationTab(slot),
          slotName: CAASContentOverviewSlotName,
          hash: TAB_NAMES.Presentation,
          hidden: false,
        };
        case 'documents': return {
          title: (_f = (_e = this.tabs) === null || _e === void 0 ? void 0 : _e.documents) === null || _f === void 0 ? void 0 : _f.documentLabel,
          renderFunction: () => this.renderDocumentListing(TAB_NAMES.Documents, false),
          hash: TAB_NAMES.Documents,
          hidden: !this.documentsTabEnabled[TAB_NAMES.Documents],
        };
        case 'software': return {
          title: this.rangeSoftwareAndFirmwareLabel,
          renderFunction: () => this.renderDocumentListing(TAB_NAMES.Software, true),
          hash: TAB_NAMES.Software,
          hidden: !this.documentsTabEnabled[TAB_NAMES.Software],
        };
        case 'softwareRegistration': return {
          title: this.softwareRegistrationLabel,
          renderFunction: this.renderSoftwareRegistration,
          hash: TAB_NAMES.SoftwareRegistration,
          hidden: isEmpty_1((_g = this.tabs) === null || _g === void 0 ? void 0 : _g.softwareRegistration),
        };
        case 'webinarsAndResources': return {
          title: this.rangeWebinarsAndResourcesLabel,
          renderFunction: this.renderWebinarsAndResources,
          hash: TAB_NAMES.WebinarAndResources,
          hidden: isEmpty_1((_h = this.tabs) === null || _h === void 0 ? void 0 : _h.webinarsAndResources),
        };
        default:
          return null;
      }
    };
    this.getTabs = (rangeTabs) => {
      const tabs = [];
      for (const key of Object.keys(rangeTabs)) {
        const tabRenderInfo = this.getTabRenderInfoByNames(key);
        if (!tabRenderInfo)
          continue;
        tabs.push(tabRenderInfo);
      }
      return tabs;
    };
    this.host = '';
    this.localeCode = undefined;
    this.productUrlParams = undefined;
    this.endpoint = undefined;
    this.appProductsLabel = undefined;
    this.commonFiltersFilterBy = undefined;
    this.facetButtonResetAllLabel = undefined;
    this.facetButtonViewLessFilters = undefined;
    this.facetButtonViewMoreFilters = undefined;
    this.nextLabel = undefined;
    this.pageLabel = undefined;
    this.noResultsClearLink = undefined;
    this.noResultsHeader = undefined;
    this.noResultsMessage = undefined;
    this.numberProductsOfAllProductsLabel = undefined;
    this.previousLabel = undefined;
    this.rangeProductLabel = undefined;
    this.rangeProductsFiltersLabel = undefined;
    this.viewLessLabel = undefined;
    this.viewMoreLabel = undefined;
    this.viewProductsLabel = undefined;
    this.rangePresentationLabel = undefined;
    this.rangeWebinarsAndResourcesLabel = undefined;
    this.softwareRegistrationLabel = undefined;
    this.rangeSoftwareAndFirmwareLabel = undefined;
    this.loadMoreLabel = undefined;
    this.loadPreviousLabel = undefined;
    this.backLabel = undefined;
    this.descriptionBigger = undefined;
    this.id = undefined;
    this.name = 'TODO';
    this.navigationState = undefined;
    this.rangeReference = undefined;
    this.onProductClick = undefined;
    this.showDocuments = undefined;
    this.tabs = undefined;
    this.enableCommerceConnector = true;
    this.showBuyOnline = true;
    this.currentReference = undefined;
    this.isPBS = false;
    this.seoURl = undefined;
    this.productCtas = undefined;
    this._host = undefined;
    this._localeCode = undefined;
    this._productUrlParams = undefined;
    this._endpoint = undefined;
    this._appProductsLabel = undefined;
    this._commonFiltersFilterBy = undefined;
    this._facetButtonResetAllLabel = undefined;
    this._facetButtonViewLessFilters = undefined;
    this._facetButtonViewMoreFilters = undefined;
    this._nextLabel = undefined;
    this._pageLabel = undefined;
    this._noResultsClearLink = undefined;
    this._noResultsHeader = undefined;
    this._noResultsMessage = undefined;
    this._numberProductsOfAllProductsLabel = undefined;
    this._previousLabel = undefined;
    this._rangeProductLabel = undefined;
    this._rangeProductsFiltersLabel = undefined;
    this._viewLessLabel = undefined;
    this._viewMoreLabel = undefined;
    this._viewProductsLabel = undefined;
    this._rangePresentationLabel = undefined;
    this._rangeWebinarsAndResourcesLabel = undefined;
    this._softwareRegistrationLabel = undefined;
    this._rangeSoftwareAndFirmwareLabel = undefined;
    this._loadMoreLabel = undefined;
    this._loadPreviousLabel = undefined;
    this._descriptionBigger = undefined;
    this._id = undefined;
    this._name = undefined;
    this._navigationState = undefined;
    this._rangeReference = undefined;
    this._showDocuments = undefined;
    this._tabs = undefined;
    this._enableCommerceConnector = undefined;
    this._showBuyOnline = undefined;
    this._currentReference = undefined;
    this._backLabel = undefined;
    this.documentListing = undefined;
    this._externalUrlConfig = undefined;
    this._externalFavoriteConfig = undefined;
    this.isExternalConsumer = undefined;
    this.externalUrlConfig = undefined;
    this.externalFavoriteConfig = undefined;
    this.externalAppRoutingEnabled = undefined;
    this.hostWithLocale = undefined;
    this.analyticsPageData = undefined;
    this.currentNode = undefined;
    this.filters = undefined;
    this.filtersNormalized = undefined;
    this.filtrationSmartData = undefined;
    this.products = [];
    this.productsCount = 0;
    this.resultsCount = undefined;
    this.firstLoadedRecNum = undefined;
    this.filterNodeId = undefined;
    this.lastLoadedRecNum = undefined;
    this.navigationStateBeforeFilterMobileViewOpen = undefined;
    this.baseFilterUrl = undefined;
    this.initialNodeIds = undefined;
    this.isResetFilters = undefined;
    this.selectedPage = undefined;
    this.filtersCategories = [];
    this.isTabsInitialized = false;
    this.isMobileCategorySelected = false;
    this.isLoading = false;
    this.documentsTabEnabled = {
      [TAB_NAMES.Documents]: false,
      [TAB_NAMES.Software]: false,
    };
    this.documentListingApiConfig = undefined;
    this.richText = undefined;
    this.pills = [];
    this.selectedSectionsCount = undefined;
    this.initialfilterUrl = undefined;
    this.selectedFilterUrl = undefined;
    this.nodeIdFromNode = undefined;
    this.nodeIdFromUrl = undefined;
    this.nodeOrSubCatId = undefined;
    this.initialNodeId = undefined;
    this.PBSoffset = 0;
  }
  documentListingReady(event) {
    const { name, hasDocuments } = event.detail;
    this.documentsTabEnabled = Object.assign(Object.assign({}, this.documentsTabEnabled), { [name]: hasDocuments });
  }
  handleNodeSelected(event) {
    var _a, _b, _c;
    const { id, nodeReference } = event.detail;
    this.PBSoffset = 0;
    this.currentNode = calculateCurrentNodeParams({
      nodeReference: this.rangeReference,
      id,
      name: this.name,
      nodes: (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products.nodes,
    }, join(getLocaleWithV3(this.localeCode, /^[^A-Z]+$/.test(this.localeCode)), rangeBasePath, this.rangeReference), nodeReference, this.backLabel);
    this.filterNodeId = this.currentNode.id;
    this.initialfilterUrl = this.getInitialFiltersUrl;
    const nodeFilterUrl = getRangeFilterUrl(this.filterNodeId, (_c = (_b = this.tabs) === null || _b === void 0 ? void 0 : _b.products) === null || _c === void 0 ? void 0 : _c.filtersUrl, this.localeCode);
    this.loadFilters(nodeFilterUrl);
  }
  onFilterStateChanged(event) {
    const { lastChangedFilterId: filterId } = event.detail;
    if (filterId) {
      const { rootSectionId, seoUrl, checkedURL, unCheckedURL, navigationState, } = this.filtersNormalized.entities.filter[filterId];
      const changedFilterUrl = unCheckedURL !== '' ? unCheckedURL : checkedURL;
      const nodeIdOnFilterChange = navigationState === DEFAULT_NAVIGATION_STATE
        ? this.nodeOrSubCatId
        : navigationState;
      this.changeFilter(changedFilterUrl, nodeIdOnFilterChange, filterReset(changedFilterUrl, this.initialfilterUrl), rootSectionId === 'product.category' ? seoUrl : '');
    }
  }
  onSelectCategoryHandler(event) {
    this.setActive(event.detail);
    this.isMobileCategorySelected = true;
  }
  resetAllFiltersHandler() {
    this.isResetFilters = true;
    this.changeFilter(this.initialfilterUrl, this.initialNodeId, true, join(getLocaleWithV3(this.localeCode, /^[^A-Z]+$/.test(this.localeCode)), 'product-range', this.initialNodeIds.rangePath));
  }
  onToggleMobileViewVisibility(event) {
    const { detail } = event;
    if (detail === null || detail === void 0 ? void 0 : detail.restore) {
      this.setActive(this.navigationStateBeforeFilterMobileViewOpen);
    }
    else if (!detail) {
      this.navigationStateBeforeFilterMobileViewOpen = this.baseFilterUrl;
    }
  }
  removePillHandler(event) {
    const unCheckedURL = event.detail;
    this.changeFilter(unCheckedURL, this.nodeOrSubCatId, filterReset(unCheckedURL, this.initialfilterUrl));
  }
  productClickHandler(event) {
    var _a;
    const productRef = event.detail;
    (_a = this.onProductClick) === null || _a === void 0 ? void 0 : _a.call(this, productRef);
  }
  choosePage(event) {
    this.selectedPage = event.detail;
    const { productsPerPage } = this.getPaginationParamsWithDefaults;
    if (!this.isPBS) {
      setPaginationParams(productsPerPage * (this.selectedPage - 1), productsPerPage, true);
    }
    this.PBSoffset = productsPerPage * (this.selectedPage - 1);
    this.loadProducts(this.selectedFilterUrl);
  }
  mobileCategoryReset() {
    this.isMobileCategorySelected = false;
  }
  trackAnalyticsEventListener(e) {
    const { event } = e.detail;
    if (!event)
      return;
    if (event === FILTER_STATE_CHANGED_EVENT_NAME)
      trackFilterAnalytics(e, this.filtersNormalized);
  }
  changeFilter(changedFilterUrl, nodeId, isReset, seoUrl) {
    if (!this.isPBS) {
      setNavigationFilterPath(changedFilterUrl, nodeId, isReset, seoUrl);
    }
    this.nodeOrSubCatId = getSelectedNodeIdFromUrl(this.initialNodeId);
    this.setActive(changedFilterUrl);
  }
  get activeCategory() {
    var _a, _b;
    const category = (_a = this.filters) === null || _a === void 0 ? void 0 : _a[0];
    return category && ((_b = category.filterRefinements.find((i) => i.checked)) === null || _b === void 0 ? void 0 : _b.label);
  }
  get getPaginationParamsWithDefaults() {
    return getPaginationParams({
      offset: 0,
      productsPerPage: Number(this.tabs.products.numberProductsOnRangePage),
    });
  }
  get getInitialFiltersUrl() {
    var _a, _b, _c;
    if (!((_c = (_b = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.nodes) === null || _c === void 0 ? void 0 : _c.length))
      return this.baseFilterUrl;
    if (!this.isPBS && this.initialNodeIds.nodeId) {
      return `${this.baseFilterUrl}&hlnode-id=${this.initialNodeIds.nodeId}`;
    }
    return this.filterNodeId
      ? `${this.baseFilterUrl}&hlnode-id=${this.filterNodeId}`
      : this.baseFilterUrl;
  }
  async loadFilters(filterUrl) {
    this.isLoading = true;
    try {
      const { filtersNormalized, filtrationSmartData, pills, filtersCategories, selectedSectionsCount, filters, } = await fetchSprykerFilters(`${this.host}${filterUrl}`);
      this.filters = filters !== null && filters !== void 0 ? filters : [];
      this.filtersNormalized = filtersNormalized;
      this.filtrationSmartData = filtrationSmartData;
      this.pills = pills !== null && pills !== void 0 ? pills : [];
      this.filtersCategories = filtersCategories;
      this.selectedSectionsCount = selectedSectionsCount > 0 ? selectedSectionsCount : 0;
    }
    catch (error) {
      this.isLoading = false;
      console.error(error);
    }
    finally {
      if (this.isResetFilters) {
        this.isResetFilters = false;
      }
      this.loadProducts(filterUrl);
    }
  }
  loadProducts(filtersUrl) {
    var _a, _b, _c, _d;
    this.isLoading = true;
    const PBSUrl = getPbsFilterProductsUrl({
      host: this.host,
      ProductsPath: (_b = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.productsUrl,
      CheckedFiltersUrl: filtersUrl,
      pbsOffset: this.PBSoffset,
      Nrpp: this.tabs.products.numberProductsOnRangePage,
    });
    const PPWUrl = getFilterProductsUrl((_d = (_c = this.tabs) === null || _c === void 0 ? void 0 : _c.products) === null || _d === void 0 ? void 0 : _d.productsUrl, this.tabs.products.numberProductsOnRangePage, this.localeCode, this.filterNodeId, { pageParam: pageParam.RANGE_LISTING, subCategoryId: '' });
    const url = !this.isPBS ? PPWUrl : PBSUrl;
    getData(false, url)
      .then((response) => {
      this.setProductsInfo(response);
    })
      .finally(() => {
      this.isLoading = false;
      this.isTabsInitialized = true;
    });
  }
  setProductsInfo(productsInfo) {
    var _a;
    if (!productsInfo)
      return;
    const { totalNumRecs, firstRecNum, recsPerPage, productIds, richText } = productsInfo;
    this.richText = parseRichText(richText);
    const productsCount = (_a = productIds === null || productIds === void 0 ? void 0 : productIds.length) !== null && _a !== void 0 ? _a : 0;
    const lastRecNum = firstRecNum + productsCount - 1;
    this.productsCount = productsInfo.totalNumRecs;
    this.resultsCount = {
      firstRecNum,
      lastRecNum,
      recsPerPage,
      totalNumRecs,
    };
    if (!isMobile()) {
      this.firstLoadedRecNum = undefined;
      this.lastLoadedRecNum = undefined;
      this.products = [];
    }
    this.firstLoadedRecNum = this.firstLoadedRecNum === undefined
      ? firstRecNum
      : Math.min(firstRecNum, this.firstLoadedRecNum);
    this.lastLoadedRecNum = this.lastLoadedRecNum === undefined
      ? lastRecNum
      : Math.max(lastRecNum, this.lastLoadedRecNum);
    this.products = productIds;
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25;
    if (!this.analyticsPageData) {
      this.analyticsPageData = getAnalyticsPageLoadData();
    }
    this.host = (_a = tryParse(this._host)) !== null && _a !== void 0 ? _a : this.host;
    this.localeCode = (_b = tryParse(this._localeCode)) !== null && _b !== void 0 ? _b : this.localeCode;
    this.productUrlParams = (_c = tryParse(this._productUrlParams)) !== null && _c !== void 0 ? _c : this.productUrlParams;
    this.endpoint = (_d = tryParse(this._endpoint)) !== null && _d !== void 0 ? _d : this.endpoint;
    this.appProductsLabel = (_e = tryParse(this._appProductsLabel)) !== null && _e !== void 0 ? _e : this.appProductsLabel;
    this.commonFiltersFilterBy = (_f = tryParse(this._commonFiltersFilterBy)) !== null && _f !== void 0 ? _f : this.commonFiltersFilterBy;
    this.facetButtonResetAllLabel = (_g = tryParse(this._facetButtonResetAllLabel)) !== null && _g !== void 0 ? _g : this.facetButtonResetAllLabel;
    this.facetButtonViewLessFilters = (_h = tryParse(this._facetButtonViewLessFilters)) !== null && _h !== void 0 ? _h : this.facetButtonViewLessFilters;
    this.facetButtonViewMoreFilters = (_j = tryParse(this._facetButtonViewMoreFilters)) !== null && _j !== void 0 ? _j : this.facetButtonViewMoreFilters;
    this.nextLabel = (_k = tryParse(this._nextLabel)) !== null && _k !== void 0 ? _k : this.nextLabel;
    this.pageLabel = (_l = tryParse(this._pageLabel)) !== null && _l !== void 0 ? _l : this.pageLabel;
    this.noResultsClearLink = (_m = tryParse(this._noResultsClearLink)) !== null && _m !== void 0 ? _m : this.noResultsClearLink;
    this.noResultsHeader = (_o = tryParse(this._noResultsHeader)) !== null && _o !== void 0 ? _o : this.noResultsHeader;
    this.noResultsMessage = (_p = tryParse(this._noResultsMessage)) !== null && _p !== void 0 ? _p : this.noResultsMessage;
    this.numberProductsOfAllProductsLabel = (_q = tryParse(this._numberProductsOfAllProductsLabel)) !== null && _q !== void 0 ? _q : this.numberProductsOfAllProductsLabel;
    this.previousLabel = (_r = tryParse(this._previousLabel)) !== null && _r !== void 0 ? _r : this.previousLabel;
    this.rangeProductLabel = (_s = tryParse(this._rangeProductLabel)) !== null && _s !== void 0 ? _s : this.rangeProductLabel;
    this.rangeProductsFiltersLabel = (_t = tryParse(this._rangeProductsFiltersLabel)) !== null && _t !== void 0 ? _t : this.rangeProductsFiltersLabel;
    this.viewLessLabel = (_u = tryParse(this._viewLessLabel)) !== null && _u !== void 0 ? _u : this.viewLessLabel;
    this.viewMoreLabel = (_v = tryParse(this._viewMoreLabel)) !== null && _v !== void 0 ? _v : this.viewMoreLabel;
    this.viewProductsLabel = (_w = tryParse(this._viewProductsLabel)) !== null && _w !== void 0 ? _w : this.viewProductsLabel;
    this.rangePresentationLabel = (_x = tryParse(this._rangePresentationLabel)) !== null && _x !== void 0 ? _x : this.rangePresentationLabel;
    this.rangeWebinarsAndResourcesLabel = (_y = tryParse(this._rangeWebinarsAndResourcesLabel)) !== null && _y !== void 0 ? _y : this.rangeWebinarsAndResourcesLabel;
    this.softwareRegistrationLabel = (_z = tryParse(this._softwareRegistrationLabel)) !== null && _z !== void 0 ? _z : this.softwareRegistrationLabel;
    this.rangeSoftwareAndFirmwareLabel = (_0 = tryParse(this._rangeSoftwareAndFirmwareLabel)) !== null && _0 !== void 0 ? _0 : this.rangeSoftwareAndFirmwareLabel;
    this.loadMoreLabel = (_1 = tryParse(this._loadMoreLabel)) !== null && _1 !== void 0 ? _1 : this.loadMoreLabel;
    this.loadPreviousLabel = (_2 = tryParse(this._loadPreviousLabel)) !== null && _2 !== void 0 ? _2 : this.loadPreviousLabel;
    this.descriptionBigger = (_3 = tryParse(this._descriptionBigger)) !== null && _3 !== void 0 ? _3 : this.descriptionBigger;
    this.id = (_4 = tryParse(this._id)) !== null && _4 !== void 0 ? _4 : this.id;
    this.name = (_5 = tryParse(this._name)) !== null && _5 !== void 0 ? _5 : this.name;
    this.navigationState = (_6 = tryParse(this._navigationState)) !== null && _6 !== void 0 ? _6 : this.navigationState;
    this.rangeReference = (_7 = tryParse(this._rangeReference)) !== null && _7 !== void 0 ? _7 : this.rangeReference;
    this.showDocuments = (_8 = tryParse(this._showDocuments)) !== null && _8 !== void 0 ? _8 : this.showDocuments;
    this.tabs = (_9 = tryParse(this._tabs)) !== null && _9 !== void 0 ? _9 : this.tabs;
    this.enableCommerceConnector = (_10 = tryParse(this._enableCommerceConnector)) !== null && _10 !== void 0 ? _10 : this.enableCommerceConnector;
    this.showBuyOnline = (_11 = tryParse(this._showBuyOnline)) !== null && _11 !== void 0 ? _11 : this.showBuyOnline;
    this.currentReference = (_12 = tryParse(this._currentReference)) !== null && _12 !== void 0 ? _12 : this.currentReference;
    this.externalUrlConfig = (_13 = tryParse(this._externalUrlConfig)) !== null && _13 !== void 0 ? _13 : this.externalUrlConfig;
    this.externalFavoriteConfig = (_14 = tryParse(this._externalFavoriteConfig)) !== null && _14 !== void 0 ? _14 : this.externalFavoriteConfig;
    this.backLabel = (_15 = tryParse(this._backLabel)) !== null && _15 !== void 0 ? _15 : this.backLabel;
    if (!this.currentReference) {
      this.currentReference = this.isPBS
        ? this.rangeReference
        : getCurrentReference(Boolean((_18 = (_17 = (_16 = this.tabs) === null || _16 === void 0 ? void 0 : _16.products) === null || _17 === void 0 ? void 0 : _17.nodes) === null || _18 === void 0 ? void 0 : _18.length), rangeBasePath);
    }
    this.currentNode = calculateCurrentNodeParams({
      nodeReference: this.rangeReference,
      id: 'root',
      name: this.name,
      nodes: (_19 = this.tabs) === null || _19 === void 0 ? void 0 : _19.products.nodes,
    }, join(getLocaleWithV3(this.localeCode, /^[^A-Z]+$/.test(this.localeCode)), 'product-range', this.rangeReference), this.currentReference, this.backLabel);
    const { offset, productsPerPage } = this.getPaginationParamsWithDefaults;
    this.selectedPage = Math.floor(offset / productsPerPage) + 1;
    this.nodeIdFromNode = (_20 = this.currentNode) === null || _20 === void 0 ? void 0 : _20.id;
    const segments = window.location.pathname
      .split('/')
      .filter((pathSegment) => pathSegment !== '');
    const pathname = !this.isPBS ? window.location.pathname : this.currentReference;
    this.initialNodeIds = getRangeNodesIds(pathname, this.rangeReference);
    if (this.currentReference === segments[segments.length - 1] && this.nodeIdFromNode) {
      this.filterNodeId = this.nodeIdFromNode;
    }
    else {
      this.filterNodeId = (_21 = this.initialNodeIds) === null || _21 === void 0 ? void 0 : _21.nodeId;
    }
    if (this.navigationState) {
      this.isMobileCategorySelected = true;
    }
    this.initialNodeId = this.navigationState;
    this.nodeOrSubCatId = getSelectedNodeIdFromUrl(this.initialNodeId);
    this.baseFilterUrl = getBaseUrl((_23 = (_22 = this.tabs) === null || _22 === void 0 ? void 0 : _22.products) === null || _23 === void 0 ? void 0 : _23.filtersUrl, this.localeCode);
    this.initialfilterUrl = this.getInitialFiltersUrl;
    this.selectedFilterUrl = getRangeFilterUrl(this.filterNodeId, (_25 = (_24 = this.tabs) === null || _24 === void 0 ? void 0 : _24.products) === null || _25 === void 0 ? void 0 : _25.filtersUrl, this.localeCode);
    this.loadFilters(this.selectedFilterUrl);
    window.addEventListener('popstate', this.handlePopState);
  }
  disconnectedCallback() {
    window.removeEventListener('popstate', this.handlePopState);
  }
  setActive(changedFilterUrl) {
    this.PBSoffset = 0;
    this.selectedPage = 1;
    this.products = [];
    this.selectedFilterUrl = changedFilterUrl;
    this.loadFilters(changedFilterUrl);
  }
  render() {
    if (!this.isTabsInitialized)
      return null;
    const tabs = this.getTabs(this.tabs).filter(Boolean);
    return (h("pes-tabs", { class: "range-tabs", tabs: tabs }, h("slot", { slot: CAASContentOverviewSlotName, name: CAASContentOverviewSlotName })));
  }
  get el() { return getElement(this); }
};
RangeTabs.style = pesSprykerRangeTabsCss;

const tabsCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}.pes-tabs{width:100%;background:#ffffff}.pes-tabs--desktop-only{display:none}@media screen and (min-width: 980px){.pes-tabs--desktop-only{display:block}}.pes-tabs .pes-tabs-hidden{display:none}.pes-tabs .tab-primary a{font-weight:400 !important;color:#626469 !important;font-size:16px !important}.pes-tabs .tab-primary a:not(.active){border-top-width:2px !important}.pes-tabs .tab-primary a:hover,.pes-tabs .tab-primary a.active{color:#333333 !important;font-weight:500 !important}.pes-tabs .tab-primary nav[dir=rtl] a{border-left:1px solid #e6e6e6 !important;border-right:0 !important}.pes-tabs .tab-primary nav[dir=rtl] a:first-child{border-right:1px solid #e6e6e6 !important}.pes-tabs__title{margin:0;font-size:inherit;font-weight:inherit;line-height:inherit}.pes-tabs-content{width:100%}.pes-tabs-content .pes-tabs-content-hidden{display:none}";

const PesTabs = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.previousListener = null;
    this.handleOverviewNavigation = () => this.handleTabClick(this.overviewTab);
    this.setExpectedActiveTab = () => {
      var _a, _b;
      const currentHash = (_b = (_a = window.location.hash) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, '#', '');
      if (!Object.values(TAB_NAMES).includes(currentHash))
        return;
      if (this.activeTabHash !== currentHash) {
        setArticleTitle(rangeTabs[currentHash]);
        this.activeTabHash = currentHash;
        scrollToTop(this.hostElementRef);
      }
    };
    this.setLocationHash = (hash) => {
      const { currentPath, currentState } = this.getRouteDetails();
      if (!hash) {
        window.history.pushState(currentState, document.title, currentPath);
        return;
      }
      window.history.pushState(currentState, document.title, `${currentPath}#${hash}`);
    };
    this.handleTabClick = (tab) => {
      if (this.activeTabHash !== tab.hash) {
        setArticleTitle(rangeTabs[tab.hash]);
        send(rangeTabClickEvent, { tabHash: tab.hash });
      }
      this.setLocationHash(tab.hideHash ? undefined : tab.hash);
      this.activeTabHash = tab.hash;
      scrollToTop(this.hostElementRef);
    };
    this.tabs = [];
    this.desktopOnly = false;
    this.activeTabHash = this.setActiveFirstTab();
    this.overviewTab = null;
  }
  connectedCallback() {
    this.setTabFromHash();
    document.addEventListener('activeOverview', this.handleOverviewNavigation);
    this.previousListener = window.onhashchange;
    const componentScope = this;
    window.onhashchange = function (...params) {
      var _a, _b;
      const result = (_b = (_a = componentScope.previousListener) === null || _a === void 0 ? void 0 : _a.apply) === null || _b === void 0 ? void 0 : _b.call(_a, this, params);
      componentScope.setExpectedActiveTab();
      return result;
    };
  }
  disconnectedCallback() {
    document.removeEventListener('activeOverview', this.handleOverviewNavigation);
    window.onhashchange = this.previousListener;
  }
  setActiveFirstTab() {
    if (this.tabs.length) {
      return this.tabs[0].hash;
    }
    return 'main';
  }
  setTabFromHash() {
    const currentHash = window.location.hash.substring(1);
    const currentTab = this.tabs.find((tab) => {
      return currentHash === tab.hash;
    });
    if (isEmpty_1(currentTab))
      return;
    this.activeTabHash = currentTab.hash;
  }
  getRouteDetails() {
    return {
      currentState: window.history.state || null,
      currentPath: window.location.pathname + window.location.search,
    };
  }
  componentWillLoad() {
    var _a;
    if (!window.location.hash) {
      this.setLocationHash(this.activeTabHash);
    }
    this.overviewTab = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.find(({ hash }) => hash.includes(TAB_NAMES.Presentation));
  }
  renderTabs() {
    return (h("nav", { dir: document.documentElement.dir || 'auto' }, this.tabs.map((tab) => (h("a", { onClick: () => this.handleTabClick(tab), class: classnames({
        active: tab.hash === this.activeTabHash,
        'pes-tabs-hidden': tab.hidden && tab.hash !== this.activeTabHash,
      }) }, h("h2", { class: "pes-tabs__title" }, tab.title))))));
  }
  render() {
    if (!this.tabs.length)
      return null;
    return (h(Host, null, h("se-container", { option: "centered", class: classnames('pes-tabs', { 'pes-tabs--desktop-only': this.desktopOnly }) }, h("se-tabbar", { option: "content" }, this.renderTabs())), h("se-container", { option: "centered", class: "pes-tabs-content", color: "standard" }, this.tabs.map(({ renderFunction, slotName, hash, hidden }) => {
      return (h("div", { class: classnames({
          'pes-tabs-content-hidden': this.activeTabHash !== hash || hidden,
        }) }, renderFunction(slotName ? h("slot", { name: slotName }) : undefined)));
    }))));
  }
  get hostElementRef() { return getElement(this); }
};
PesTabs.style = tabsCss;

export { RangeCTA as pes_range_cta, RangeInfo$1 as pes_range_info, RangeMain as pes_range_main, RangeInfo as pes_range_node_card, RangeNodes as pes_range_nodes, RangePresentationTab as pes_range_presentation_tab, RangeProductsTab as pes_range_products_tab, RangeSoftwareRegistrationTab as pes_range_software_registration_tab, RangeWebinarsAndResourcesTab as pes_range_webinars_and_resources_tab, SDLContent as pes_sdl_content, RangeTabs as pes_spryker_range_tabs, PesTabs as pes_tabs };
